<div  mat-dialog-container  style="border: solid 4px #F57C22; height: 100vh; width: 100%;" class="pdf-container-dialog">
  <ngx-extended-pdf-viewer *ngIf="file" [src]="file" [height]="'100%'"></ngx-extended-pdf-viewer>
</div>
